import React, { useState, useEffect } from "react";
import { Table, Pagination } from "semantic-ui-react";

const DEFAULT_PAGE_SIZE = 25;

const AssetMainTable = ({
  columns = [],
  data = [],
  rowKey = "id",
  selectedRowId,
  onSelectRow,
  pageSize = DEFAULT_PAGE_SIZE,
}) => {
  const [activePage, setActivePage] = useState(1);

  const getRowId = (row) =>
    typeof rowKey === "function" ? rowKey(row) : row[rowKey];

  const getCellValue = (row, col) => {
    const accessor = col.accessor;
    const raw =
      typeof accessor === "function"
        ? accessor(row)
        : (row[accessor] ?? "");
    return col.format ? col.format(raw) : raw;
  };

  const usePagination = pageSize > 0;
  const totalPages = usePagination
    ? Math.max(1, Math.ceil(data.length / pageSize))
    : 1;
  const start = usePagination ? (activePage - 1) * pageSize : 0;
  const end = usePagination ? start + pageSize : data.length;
  const pageData = data.slice(start, end);

  useEffect(() => {
    if (activePage > totalPages && totalPages > 0) {
      setActivePage(totalPages);
    }
  }, [data.length, pageSize, activePage, totalPages]);

  const handlePageChange = (e, { activePage: next }) => {
    setActivePage(next);
  };

  return (
    <div className="height-100 gs-flex-container-vertical">
      <div className="table-overflow flex-stretch-vertical">
        <Table
          celled
          selectable
          unstackable
          compact
        >
          <Table.Header style={{ position: "sticky" }}>
            <Table.Row>
              {columns.map((col) => (
                <Table.HeaderCell key={col.key}>{col.label}</Table.HeaderCell>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {pageData.map((row) => (
              <Table.Row
                key={getRowId(row)}
                active={selectedRowId === getRowId(row)}
                onClick={() => onSelectRow(row)}
                className="clickable"
              >
                {columns.map((col) => (
                  <Table.Cell key={col.key}>
                    {getCellValue(row, col)}
                  </Table.Cell>
                ))}
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      {usePagination && data.length > 0 && (
        <div className="mt-0_5 flex-end" style={{ flexShrink: 0 }}>
          <Pagination
            size="mini"
            activePage={activePage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            firstItem={null}
            lastItem={null}
          />
        </div>
      )}
    </div>
  );
};

export default AssetMainTable;
